import { Platform } from 'react-native';

// Web-specific imports
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

// Native-specific imports (named API)
import messaging from '@react-native-firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyCTgFQMU6mT--hqrq16JQDPrR3Dc9tMuiE",
  authDomain: "eventapp-a504d.firebaseapp.com",
  projectId: "eventapp-a504d",
  storageBucket: "eventapp-a504d.firebasestorage.app",
  messagingSenderId: "923349513093",
  appId: "1:923349513093:web:243979e9cf2e0165204aec",
};

let app;
let messagingInstance;

if (Platform.OS === 'web') {
  app = initializeApp(firebaseConfig);
  messagingInstance = getMessaging(app);
}

export const requestNotificationPermission = async () => {
  if (Platform.OS === 'web') {
    try {
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        const token = await getToken(messagingInstance, {
          vapidKey: 'YOUR_VAPID_KEY',
        });
        return token;
      }
    } catch (error) {
      console.error('Web notification permission error:', error);
    }
  } else {
    try {
      const authStatus = await messaging().requestPermission(); // OK as per current version
      const enabled =
        authStatus === messaging.AuthorizationStatus.AUTHORIZED ||
        authStatus === messaging.AuthorizationStatus.PROVISIONAL;
      if (enabled) {
        const token = await messaging().getToken();
        return token;
      }
    } catch (error) {
      console.error('Native notification permission error:', error);
    }
  }
};

export const onMessageListener = () => {
  if (Platform.OS === 'web') {
    return new Promise((resolve) => {
      onMessage(messagingInstance, (payload) => {
        resolve(payload);
      });
    });
  } else {
    return new Promise((resolve) => {
      messaging().onMessage(async (remoteMessage) => {
        resolve(remoteMessage);
      });
    });
  }
};
